import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from './config/firebase'
import i18n from './config/i18n'
import store from './config/store'
import Buefy from 'buefy'

require('./style/app.scss');

Vue.use(Buefy);

Vue.config.productionTip = false;

let app;

function initialize() {
    app = new Vue({
        i18n,
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
}


firebase.auth().onAuthStateChanged(function (user) {

        if (!app) {
            if (user) {
                store.dispatch('init', user).then(() => {
                    initialize();
                });
            }
            else initialize();
        }
    }
);

